import type { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS } from 'common/constants/ai';

export const containerSx: SxProps<Theme> = {
  position: 'relative',
  mx: 1,
  mt: 0.75,
  mb: 0.5,
};

export const textFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    backgroundColor: 'background.paper',
    transition: 'box-shadow 200ms ease',
    '&:hover': {
      boxShadow: '0 0 0 1px rgba(79, 85, 231, 0.25)',
    },
    '&.Mui-focused': {
      boxShadow: '0 0 0 2px rgba(79, 85, 231, 0.35)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
      borderWidth: 1,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderImage: `${AI_GRADIENT_CSS} 1`,
  },
  '& .MuiInputBase-input': {
    fontSize: '0.875rem',
    py: 1,
  },
};

export const iconSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  fontSize: '1.25rem',
};

export const sendButtonSx: SxProps<Theme> = {
  color: 'primary.main',
  '&:disabled': {
    color: 'action.disabled',
  },
};
